module.exports = __webpack_public_path__ + "img/target_icon02.7db9906a.png";